import React from "react";

export {WAMTBPPending};

const WAMTBPPending = (props: any) => {
  
  return(<>Aaa</>);
};